import React, {useEffect, useState} from 'react';
import classNames from "classnames";
import Grid from  '../grid/grid';
import GridLine from  '../grid-line/grid-line';
import './subcategory.scss';
import PreviewContent from '../preview/preview';
import { ReactCompareSlider, ReactCompareSliderImage, ReactCompareSliderHandle } from 'react-compare-slider';

const SubCategory = ({
    backgroundColor,
    categoryName,
    description,
    h1,
    html,
    images,
    imagesGrid,
    projects,
    title,
    titleLink,
    video,
    videos,
    compareSlider
  }) => {
  const worksData = projects?.join(',');

  const [isLoading, setIsLoading] = useState(worksData === '5018');

  useEffect(() => {
    if (!isLoading) return;

    let animationId;

    const applyChanges = () => {
      const el = document.querySelector('.p-v3-grid-item-id-5018');

      if (el) {
        if (!el.classList.contains('p-v5-grid-item-large')) {
          el.classList.add('p-v5-grid-item-large');
        }
        if (el.classList.contains('p-v5-grid-item-small')) {
          el.classList.remove('p-v5-grid-item-small');
        }

        const imagePath5018 = '/competencies/images/master-plan/yakutsk.png';
        const previewEl = el.querySelector('.p-v5-grid-item-preview');

        if (!previewEl.querySelector('.image')) {
          previewEl.innerHTML = `
            <div class="image">
              <img src="${imagePath5018}" class="">
            </div>
          `;
        }

        const titleOElement = el.querySelector('.p-v5-grid-item-title');

        if (titleOElement) {
          titleOElement.style.borderRadius = '0 0 4px 4px';
        }

        const itemOElement = el.querySelector('.p-v5-grid-item-o');

        if (itemOElement && !itemOElement.parentElement.classList.contains('p-v5-grid-item-title-descr-title')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'p-v5-grid-item-title-descr-title';

          itemOElement.parentNode.replaceChild(wrapper, itemOElement);
          wrapper.appendChild(itemOElement);
        }
      }
    };

    const onResize = () => {
      console.log('onResize')
      applyChanges();
    };

    const onInit = () => {
      const el = document.querySelector('.p-v3-grid-item-id-5018');

      if (el?.classList.contains('p-v3-grid-item-inited')) {
        applyChanges();
        window.addEventListener('resize', onResize);
        console.log('onResize setted')
        setIsLoading(false);
      } else {
        animationId = requestAnimationFrame(onInit);
      }
    };

    animationId = requestAnimationFrame(onInit);

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', onResize);
    };
  }, [isLoading]);

  return (
    <React.Fragment>
      <div className={classNames(
        'services-container',
        categoryName ? `${'services-container'}_${categoryName}` : ''
      )} style={{backgroundColor: backgroundColor}}>
        {(title || description) && (
          <div className="als-text-container">
            {h1 && <h1 className="services-container__header" dangerouslySetInnerHTML={{__html: h1}} />}
            {title && <h2 className="services-container__header" dangerouslySetInnerHTML={{__html: title}} />}
            {titleLink && <p className="services__text services__title-link"><a href={titleLink.link}>{titleLink.text}</a></p>}
            {description && <p className="services__text"
                               dangerouslySetInnerHTML={{__html: description}}
            />}
          </div>
        )}
        {(images?.length || videos?.length) && (
          <div>
            {images?.length && (
              <div className={classNames(
                'services-container__images',
                imagesGrid ? `${'services-container__images-grid services-container__images-grid'}-${imagesGrid}` : ''
              )}>
                {images.map((image) => <img alt="" src={image}/>)}
              </div>
            )}
            {videos?.length && (
              <div className="services-container__videos">
                {videos.map((video) => <PreviewContent content={video}/>)}
              </div>
            )}
          </div>
        )}
        {projects && <div className="works-data" data-works-ids={projects.join(',')} />}
        {video && (
          <Grid>
            <GridLine>
              <div className="services-container__video">
                <div>
                  <iframe width="100%" height="auto" src={video} frameBorder="0" allowFullScreen="" />
                </div>
              </div>
            </GridLine>
          </Grid>
        )}
        {html && <div className="services__content" dangerouslySetInnerHTML={{ __html: html }} />}

        {compareSlider && <div className="services__compare-slider-container"><ReactCompareSlider
            className="services__compare-slider"
            itemOne={<ReactCompareSliderImage src={compareSlider.before} alt=""/>}
            itemTwo={<ReactCompareSliderImage src={compareSlider.after} alt=""/>}
            sliderLineWidth="0"
            handle={<ReactCompareSliderHandle linesStyle={{width: '1px'}}/>}
        /><div className="services__compare-slider-labels"><div>До</div><div>После</div></div></div>}
      </div>
    </React.Fragment>
  );
}

export default SubCategory;
